import React, { useContext, useState } from "react";
import AppContext from "../contexts/AppContext";
import renderComponent from "../renderComponent";

function ChartWrapperControl1({ subcomponents }) {
  console.log("subcomponents");
  const [selectedChartControl, setSelectedChartControl] = useState(null);

  let [chartFilter, chartControl] = subcomponents;
  let customSubcomponents = [chartFilter, selectedChartControl];

  let subcomponentstoUse = [];

  if (selectedChartControl) {
    subcomponentstoUse = customSubcomponents;
  } else {
    subcomponentstoUse = subcomponents;
  }

  console.log("the subcomponentstoUse", subcomponentstoUse);

  return (
    <>
      {subcomponentstoUse?.map((config, idx) =>
        renderComponent(config, {
          selectedChartControl,
          setSelectedChartControl,
        })
      )}
    </>
  );
}

export default ChartWrapperControl1;
